export default __webpack_public_path__ + "static/media/info.a0c83ce2.svg";